export const defaultBusinessUnits = [
    {
        id: 1,
        name: "Advisory",
    },
    {
        id: 2,
        name: "Digital",
    },
];